document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const buttons = document.querySelectorAll('[data-cta]');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      window.location.href = '/collections/all';
    });
  });

  const galleries = document.querySelectorAll('[data-product-gallery]');
  galleries.forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-gallery-main-image]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!mainImage) return;
        const nextUrl = thumb.getAttribute('data-image-url');
        const nextAlt = thumb.getAttribute('data-image-alt') || '';

        if (nextUrl) {
          mainImage.setAttribute('src', nextUrl);
          mainImage.setAttribute('alt', nextAlt);
        }

        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  const productForms = document.querySelectorAll('[data-product-form]');
  productForms.forEach((form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    const variantIdInput = form.querySelector('[data-variant-id-input]');

    if (!variantSelect || !variantIdInput) return;

    variantSelect.addEventListener('change', () => {
      const selectedId = variantSelect.value;
      variantIdInput.value = selectedId;
    });
  });

  const revealItems = document.querySelectorAll('[data-reveal]');
  if (revealItems.length > 0) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.22,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      revealItems.forEach((item) => revealObserver.observe(item));
    }
  }

  const parallaxItems = document.querySelectorAll('[data-parallax]');
  if (!prefersReducedMotion && parallaxItems.length > 0) {
    let rafHandle = null;

    const updateParallax = () => {
      const viewportHeight = window.innerHeight || 1;

      parallaxItems.forEach((item) => {
        const speed = Number.parseFloat(item.getAttribute('data-parallax') || '0.08');
        const rect = item.getBoundingClientRect();
        const midpoint = rect.top + rect.height / 2;
        const offsetFromCenter = midpoint - viewportHeight / 2;
        const shift = Math.max(-26, Math.min(26, offsetFromCenter * speed * -0.1));

        item.style.setProperty('--parallax-y', `${shift.toFixed(2)}px`);
      });

      rafHandle = null;
    };

    const requestParallaxUpdate = () => {
      if (rafHandle !== null) return;
      rafHandle = window.requestAnimationFrame(updateParallax);
    };

    requestParallaxUpdate();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);
  }
});
